<template>
  <div>
    <b-container v-if="isLoading" class="text-center d-flex justify-content-center">
      <b-form>
        <br><br><br>
        <h5>ladevorgang</h5>
        <br>
        <b-spinner style="color: rgb(109,122,82) !important" variant="warning"></b-spinner>
      </b-form>
    </b-container>
    <div v-else>
      <b-row style="height:40vh;margin:0" class="welcome-picture">
        <b-col cols="1" sm="2"></b-col>
        <b-col cols="10" sm="8" style="height:100%">
          <div class="language">
            <template>
              <b-dropdown left split text="language" 
                class="language-dropdown-white" 
                toggle-class="toggle-language-white" 
                split-class="split-language-white" 
                style="font-size: 12px;"
              >
                <template #button-content>
                  <img
                    :src="currentLanguageFlag"
                    style="width:28px; height:19px; border-radius:2px;"
                  >
                </template>

                <!-- Dropdown Items -->
                <b-dropdown-item @click="selectLanguage('en')">
                  <img :src="require('@/assets/img/flags/english.png')" style="width: 37px; height: 25px;">
                  English
                </b-dropdown-item>
                <b-dropdown-item @click="selectLanguage('fr')">
                  <img :src="require('@/assets/img/flags/francais.png')" style="width: 37px; height: 25px;">
                  Français (French)
                </b-dropdown-item>
                <b-dropdown-item @click="selectLanguage('de')">
                  <img :src="require('@/assets/img/flags/deutsch.png')" style="width: 37px; height: 25px;">
                  Deutsch (German)
                </b-dropdown-item>
                <b-dropdown-item @click="selectLanguage('es')">
                  <img :src="require('@/assets/img/flags/spanish.png')" style="width: 37px; height: 25px;">
                  Español (Spanish)
                </b-dropdown-item>
                <b-dropdown-item @click="selectLanguage('it')">
                  <img :src="require('@/assets/img/flags/italian.png')" style="width: 37px; height: 25px;">
                  Italiano (Italian)
                </b-dropdown-item>
                <b-dropdown-item @click="selectLanguage('nl')">
                  <img :src="require('@/assets/img/flags/dutch.png')" style="width: 37px; height: 25px;">
                  Nederlands (Dutch)
                </b-dropdown-item>
                <b-dropdown-item @click="selectLanguage('pt')">
                  <img :src="require('@/assets/img/flags/portuguese.png')" style="width: 37px; height: 25px;">
                  Português (Portuguese)
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </div>
          <div class="welcome-overlay">
            <h1 class="main-title"><span style="color: rgb(195,147,130)">WYNE</span>LOVER</h1>
            <p class="main-subtitle">von weinliebhabern gemacht – für weinliebhaber</p>
          </div> 
        </b-col>
      </b-row> 
      <b-row>
        <b-col cols="1" sm="2"></b-col>
        <b-col cols="10" sm="8">
          <p class="w-title">Wir sind eine Gruppe leidenschaftlicher Weinliebhaber.</p>
          <p class="w-text">Unsere Mission ist es, das digitale Weinerlebnis auf offene und nicht-kommerzielle Weise zu verbessern. Deshalb haben wir <b>WyneLover</b> ins Leben gerufen.</p>
          <p class="w-text">In der ersten Phase entwickeln wir eine Trilogie miteinander verbundener Online-Anwendungen: WyneMaker, WyneCellar & WyneTaster.</p>

          <b-row>
            <b-col sm="3">
              <p class="w-text text-left">
                <a style="color: rgb(112,112,112)" href="http://www.wynemaker.com"><b>www.wynemaker.com</b></a>
              </p>
            </b-col>
            <b-col>
              <p class="w-text text-left">Für Weinproduzenten, um detaillierte Informationen über ihr Weingut und ihre Weine zu teilen.</p>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="3">
              <p class="w-text text-left">
                <a style="color: rgb(112,112,112)" href="http://www.wynecellar.com"><b>www.wynecellar.com</b></a>
              </p>
            </b-col>
            <b-col>
              <p class="w-text text-left">Für Weinliebhaber zur Verwaltung und Organisation ihres persönlichen Weinkellers.</p>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="3">
              <p class="w-text text-left">
                <a style="color: rgb(112,112,112)" href="http://www.wynetaster.com"><b>www.wynetaster.com</b></a>
              </p>
            </b-col>
            <b-col>
              <p class="w-text text-left">Zum Organisieren oder Teilnehmen an Weinverkostungen und zur Verwaltung Ihrer Verkostungsnotizen.</p>
            </b-col>
          </b-row>

          <p class="w-text">Sobald die WyneDatabase ausreichend von Produzenten befüllt ist, die die WyneMaker-App verwenden, möchten wir sie der Welt über eine offene API zugänglich machen – zum Nutzen von Weinliebhabern, Fachleuten und Entwicklern.</p>
          
          <hr>

          <p class="w-title">Wie können Sie helfen?</p>
          <p class="w-subtitle">Aktive Unterstützung</p>
          <p class="w-text">Wir suchen leidenschaftliche Freiwillige mit vielfältigen Fähigkeiten, die uns helfen, das Projekt abzuschließen und bekannt zu machen:</p>
          <p class="w-text" style="margin:15px">&#9642; Marketing und Promotion</p>
          <p class="w-text" style="margin:15px">&#9642; Weinkenntnisse (regional oder allgemein)</p>
          <p class="w-text" style="margin:15px">&#9642; Webdesign, UI/UX</p>
          <p class="w-text" style="margin:15px">&#9642; Sprach- und Kommunikationsfähigkeiten in verschiedenen Ländern</p>
          <p class="w-text" style="margin:15px">&#9642; Kontakte zu Weinproduzenten, Verbänden, Weinzeitschriften</p>
          <p class="w-text">Wenn Sie die digitale Zukunft des Weins mitgestalten möchten und sich dem Team anschließen wollen, würden wir uns sehr freuen, von Ihnen zu hören.</p>
          <p class="w-text">Interesse, ein <b>WyneBassador</b> zu werden?</p>
          <p class="w-text">Schreiben Sie uns eine E-Mail an <b>admin@wynelover.com</b> und sagen Sie uns, wie Sie zum Projekt beitragen können.</p>
          
          <p class="w-subtitle">Passive Unterstützung</p>
          <p class="w-text">Wir verpflichten uns, dieses Projekt offen und nicht-kommerziell zu halten. Das bedeutet, dass wir vollständig auf Spenden angewiesen sind. Wenn Ihnen gefällt, was wir aufbauen, und Sie uns unterstützen möchten, klicken Sie bitte auf den Spenden-Button unten.</p>

          <hr>

          <b-row>
            <b-col class="text-left">
              <b-button v-on:click="onBack()" class="w-button-pink">zurück</b-button>
            </b-col>
            <b-col class="text-right">
              <b-button v-on:click="onDonate()" class="w-button-green">spenden</b-button>
            </b-col>
          </b-row>
          <br>    
        </b-col>
      </b-row>
      <br>  
    </div>
  </div>
</template>

<script>
  export default {
    name: 'WineryWelcome',
     computed : {
      inSession() {
        return this.$store.state.inSession
      },
      currentUserID() {
        return this.$store.state.user_id
      },
      currentUser() {
        return this.$store.state.user
      },
      currentLanguage() {
        return this.$store.state.language
      },
      currentLanguageFlag() {
        const flags = {
          en: require('@/assets/img/flags/english.png'),
          fr: require('@/assets/img/flags/francais.png'),
          de: require('@/assets/img/flags/deutsch.png'),
          es: require('@/assets/img/flags/spanish.png'),
          it: require('@/assets/img/flags/italian.png'),
          nl: require('@/assets/img/flags/dutch.png'),
          pt: require('@/assets/img/flags/portuguese.png')
        }
        return flags[this.currentLanguage] || flags.en
      },  
      currentProfilePicture() {
        return this.$store.state.profile_picture
      },
      previousPage() {
        return this.$store.state.previous_page
      },
    },
    data() {
      return {
        debug: false, 
        isLoading: true,
      }
    }, 
    mounted() {
      this.isLoading = false
    },
    methods: {
      onBack() {
        this.$store.commit('setPage','Index')
        this.$router.push({path:'/'} );
      },
      onDonate() {
        window.open('https://www.paypal.com/donate/?hosted_button_id=968LLYKG8YBP6');
      },
      
      async selectLanguage(language) {
        let local_debug = false
        if (local_debug || this.debug) console.log("Login.selectLanguage: START");
        this.language = language
        this.$store.commit('setLanguage',language)

        if (local_debug || this.debug) console.log("Login.selectLanguage: language set to ", language);

        if (local_debug || this.debug) console.log("Login.selectLanguage: STOP");
      }, 

      translate(string) {
        // console.log("TMP string: ", string, " language: ", this.currentLanguage, " translation: ",translate_word(string, this.currentLanguage) )
        return translate_word(string, this.currentLanguage);
      },
    }
  }
</script>

<style>
@import url("../../assets/styles/wynestyle.css");
</style>

<style scoped>
.welcome-picture {
    width:100vw;
    height:auto;
    
    background-image: url("../../assets/img/header.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;

    position:relative;
}
.welcome-overlay {
  width:100%;
  max-width: none !important; 
  position: relative;
  top: 10vh;
}

.language {
  position: fixed;
  top: 5px;
  left: 5px;
  color: white;
  z-index: 10;  
}
</style> 